import React from "react";
import FormikSearchSelector from 'gui/components/formikSearchSelector/FormikSearchSelector';
import {SelectOption} from 'react-select-material-ui';
import ObjectArrarify from 'object-arrarify';
import {IProduct} from "data/interfaces/products";


export interface IBaggageSelectorProps {
  label: string;
  baggageTypes: SelectOption[];
}

const generateCheckedBaggateText = (product: Partial<IProduct>) => {
  if (product.ticketDetails && product.ticketDetails.baggage > 0) {
    const baggageText = baggageTypes.find(({value}) => value === product.ticketDetails.baggage);
    if (baggageText && baggageText.label) {
      return baggageText.label;
    }
    return ['מזזודה עד', product.ticketDetails.baggage, 'ק"ג'].join(' ');
  }
  return ''
};

export const generateBaggageText = (product: Partial<IProduct>) => {
  const luggageDetails = [];
  const checkedBaggage = generateCheckedBaggateText(product);
  if (checkedBaggage) {
    luggageDetails.push(checkedBaggage)
  }
  if (!!product.ticketDetails.handBag) {
    luggageDetails.push("טרולי");
  }
  if (luggageDetails.length > 0) {
    return luggageDetails.reverse().join(" , ")
  }
  return "לא כלול במחיר";
};

const BaggageSelector = (props: IBaggageSelectorProps) => {
  return (
    <FormikSearchSelector
      options={props.baggageTypes}
      isSearchable={false}
      isClearable={false}
      {...props}
    />
  );
};


export const baggageTypes = ObjectArrarify({
  "ללא": 0,
  "מזוודה": 1,
  "שתי מזוודות": 2,
})
  .mapToArray((value, key) => ({label: key, value: value}));
BaggageSelector.defaultProps = {
  baggageTypes: baggageTypes
};

export default React.memo(BaggageSelector);
